import React from 'react';
import ActionSheet from '../../../components/v2/ActionSheet/ActionSheet';
import Button from '../../../components/v2/Button/Button';
import Icon from '../../../components/v2/Icon/Icon';
import { useCreateNewDeviceForm } from '../../../plugins/device/src/components/NewDeviceForm';
import { refetchActiveQueries } from '../../../utils/QueryClientProvider';
import { useTranslation } from 'react-i18next';
import { useCreateManyDevicesForm } from '../../../plugins/device/src/components/AddManyDevicesForm';
import scheduleMicrotask from '../../../utils/schedule-microtask';
import { useDataContext } from '../../../components/v2/Data/DataContext';

const AddAssetsButton = React.forwardRef<HTMLButtonElement, any>(
  ({ ownerState, ...props }, ref) => (
    <Button
      {...props}
      ref={ref}
      variant="text-primary"
      size={'large'}
      startIcon={<Icon name="fa-regular fa-square-plus" />}
    />
  ),
);

type Props = {
  allowTypeChange?: boolean;
  defaultType?: { value: number; label: string };
  onSuccess?(): void;
};

const AddAssetsActions = ({
  defaultType,
  allowTypeChange,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();
  const openNewDeviceForm = useCreateNewDeviceForm();
  const openManyDevicesForm = useCreateManyDevicesForm();
  const { refresh } = useDataContext();

  const handleSuccess = () => {
    onSuccess?.();

    void scheduleMicrotask(() => {
      void refetchActiveQueries();
      refresh();
    });
  };

  return (
    <ActionSheet
      button={AddAssetsButton}
      actions={[
        {
          icon: <Icon name="fa-light fa-dice-one" />,
          label: t('assets.add_one'),
          action() {
            openNewDeviceForm({ onSuccess: handleSuccess, defaultType });
          },
        },
        {
          icon: <Icon name="fa-solid fa-list" />,
          label: t('assets.add_series'),
          action() {
            openManyDevicesForm({
              onSuccess: handleSuccess,
              defaultType,
              allowTypeChange,
            });
          },
        },
      ]}
    />
  );
};

export default AddAssetsActions;
